// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itnetworkfirstpage-about-container {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  min-height: calc(100vh - nav-height);
  margin-top: 80px;
}

.itnetworkfirstpage-image-section {
  width: 60%;
  position: relative;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}

.itnetworkfirstpage-about-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.itnetworkfirstpage-text-section {
  width: 85%;
  background-color: #008392;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
  margin-left: -6%;
}

.itnetworkfirstpage-about-container::before {
  content: "";
  position: absolute;
  z-index: 2;
  background: linear-gradient(to bottom right, #008392, rgba(214, 215, 219, 0));
  pointer-events: none;
  left: 39% !important;
  width: 3%;
  height: 150%;
  top: -25%;
  transform: skewX(-9deg) translate(-5px, 10px);
}

.itnetworkfirstpage-text-section h1 {
  font-size: 3em;
  margin-top: -100px;
  margin-bottom: 10px;
  z-index: 3;
  font-family: Arial, Helvetica, sans-serif;
}

.itnetworkfirstpage-text-section p {
  font-size: 1.3em;
  text-align: center;
  padding: 0 20px;
  z-index: 3;
}

@media (max-width: 768px) {
  .itnetworkfirstpage-about-container {
    flex-direction: column;
    height: auto;
  }

  .itnetworkfirstpage-image-section {
    width: 100%;
    height: 55vh;
    clip-path: none;
  }

  .itnetworkfirstpage-text-section {
    width: 100%;
    height: 30vh;
    margin-left: 0;
    clip-path: none;
    padding: 20px;
  }

  .itnetworkfirstpage-text-section h1 {
    font-size: 2em;
    margin-right: 60px;
    margin-top: -40px;
  }

  .itnetworkfirstpage-text-section p {
    font-size: 1em;
    margin-left: -20px;
    text-align: left;
  }

  .itnetworkfirstpage-about-container::before {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ITNetworkFirst/ITNetworkFirst.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,6EAA6E;EAC7E,oBAAoB;EACpB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".itnetworkfirstpage-about-container {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n  min-height: calc(100vh - nav-height);\n  margin-top: 80px;\n}\n\n.itnetworkfirstpage-image-section {\n  width: 60%;\n  position: relative;\n  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\n}\n\n.itnetworkfirstpage-about-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.itnetworkfirstpage-text-section {\n  width: 85%;\n  background-color: #008392;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);\n  margin-left: -6%;\n}\n\n.itnetworkfirstpage-about-container::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  background: linear-gradient(to bottom right, #008392, rgba(214, 215, 219, 0));\n  pointer-events: none;\n  left: 39% !important;\n  width: 3%;\n  height: 150%;\n  top: -25%;\n  transform: skewX(-9deg) translate(-5px, 10px);\n}\n\n.itnetworkfirstpage-text-section h1 {\n  font-size: 3em;\n  margin-top: -100px;\n  margin-bottom: 10px;\n  z-index: 3;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.itnetworkfirstpage-text-section p {\n  font-size: 1.3em;\n  text-align: center;\n  padding: 0 20px;\n  z-index: 3;\n}\n\n@media (max-width: 768px) {\n  .itnetworkfirstpage-about-container {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .itnetworkfirstpage-image-section {\n    width: 100%;\n    height: 55vh;\n    clip-path: none;\n  }\n\n  .itnetworkfirstpage-text-section {\n    width: 100%;\n    height: 30vh;\n    margin-left: 0;\n    clip-path: none;\n    padding: 20px;\n  }\n\n  .itnetworkfirstpage-text-section h1 {\n    font-size: 2em;\n    margin-right: 60px;\n    margin-top: -40px;\n  }\n\n  .itnetworkfirstpage-text-section p {\n    font-size: 1em;\n    margin-left: -20px;\n    text-align: left;\n  }\n\n  .itnetworkfirstpage-about-container::before {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
